import { BoardPosition, WordDirection, BoardWord } from './vowelboard';

export function directionOfSelection(existingSelections: BoardPosition[]):WordDirection {
    //two points form a line
    if (existingSelections.length < 2) {
        return null;
    }
    var first = existingSelections[0];
    var second = existingSelections[1];
    if (second.Row == first.Row && second.Col > first.Col) return "right"
    if (second.Row == first.Row && second.Col < first.Col) return "left"
    if (second.Row > first.Row && second.Col == first.Col) return "down"
    if (second.Row < first.Row && second.Col == first.Col) return "up"

    
    
    let deltaRow = second.Row - first.Row;
    let deltaCol = second.Col - first.Col;
    if (deltaRow == deltaCol  && deltaRow > 0) return "rightDown"
    if (deltaRow == deltaCol  && deltaRow < 0) return "leftUp"

    if (deltaRow == (-1 * deltaCol) && deltaRow > 0) return "leftDown"
    if (deltaRow == (-1 * deltaCol) && deltaRow < 0) return "rightUp"

    return null;
}

export function posEqual(a: BoardPosition, b: BoardPosition): boolean {
    return a.Col == b.Col && a.Row == b.Row;
}

export function wordEqual(a: BoardWord, b: BoardWord): boolean {
    return posEqual(a.Position, b.Position) && (a.Direction == b.Direction) && (a.Word == b.Word)
}

export function moveInDirection(pos: BoardPosition, dir: WordDirection): BoardPosition {
    if (dir == "right") return { Row: pos.Row, Col: pos.Col + 1 }
    if (dir == "left") return { Row: pos.Row, Col: pos.Col - 1 }
    if (dir == "up") return { Row: pos.Row - 1, Col: pos.Col }
    if (dir == "down") return { Row: pos.Row + 1, Col: pos.Col }
    if (dir == "rightUp") return { Row: pos.Row - 1, Col: pos.Col + 1 }
    if (dir == "leftUp") return { Row: pos.Row - 1, Col: pos.Col - 1 }
    if (dir == "rightDown") return { Row: pos.Row + 1, Col: pos.Col + 1 }
    if (dir == "leftDown") return { Row: pos.Row + 1, Col: pos.Col - 1 }
    return pos;
}

export function isPositionInWord(pos: BoardPosition, word: BoardWord): boolean {
    let checkPos = word.Position;
    if (posEqual(pos, checkPos)) return true;
    for (var i = 0; i < word.Word.length-1; i++) {
        checkPos = moveInDirection(checkPos, word.Direction);
        if (posEqual(pos, checkPos)) return true;
    }
    return false;
}

export function numWordsAtPosition(pos: BoardPosition, wordList: BoardWord[]): number {
    return wordList.reduce((sum, word) => sum + (isPositionInWord(pos,word) ? 1 : 0), 0);
}


export function selectionStartsOrExtendsDirection(existingSelections: BoardPosition[], newSelection:BoardPosition): boolean {
    var dir = directionOfSelection(existingSelections);
    if (existingSelections.length > 1 && !dir) {
        return false;
    }
    if (existingSelections.length == 0) {
        return true;
    }
    if (existingSelections.length == 1) {
        dir = directionOfSelection([...existingSelections, newSelection]);
        if (!dir) return false;
    }

    var lastSelection = existingSelections[existingSelections.length -1];
    if (lastSelection == newSelection) {
        return false;
    }
    var expectedSelection = moveInDirection(lastSelection, dir);
    var equal = posEqual(expectedSelection, newSelection);

    return equal
}